import { createSlice } from '@reduxjs/toolkit';
import { generateRandomString } from '../../helper';

const initialState = {
  menuDay: {},
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    // Додає пусте меню дня (Потрібно для того щоб отримати коректну дату)
    addMenuDayDefaultRedux(state) {
      const menuDayDefault = {
        id: 'menu_day_' + new Date().getTime(),
        menu_history_id: 'menu_history_id_' + new Date().getTime(),
        dayNumber: 0, //Який день харчування в групі
        training: null, //Посилання на відео з тренуванням

        breakfast: {
          id: 'breakfast_' + new Date().getTime() + 1,
          mealName: 'breakfast',
          mealTime: '',
          title: 'Сніданок',
          twoServings: false, //Якщо меню на дві порції то буде true
          repeatMenu: false, //Якщо меню було вставлене з попередньго дня
          repeatMenuTitle: 'Повторюємо сніданок попереднього дня',
          titleBtn: '+ Страва сніданку',
          menuView: 0,
          menuText: [],
        },
        snack: {
          id: 'snack_' + new Date().getTime() + 2,
          mealName: 'snack',
          mealTime: '',
          title: 'Перекус',
          repeatMenuTitle: 'Повторюємо перекус попереднього дня',
          titleBtn: '+ Страва перекусу',
          menuView: 0,
          twoServings: false,
          repeatMenu: false,
          menuText: [],
        },
        dinner: {
          id: 'dinner_' + new Date().getTime() + 3,
          mealName: 'dinner',
          mealTime: '',
          title: 'Обід',
          repeatMenuTitle: 'Повторюємо обід попереднього дня',
          titleBtn: '+ Страва обіду',
          menuView: 0,
          twoServings: false,
          repeatMenu: false,
          menuText: [],
        },
        supper: {
          id: 'supper_' + new Date().getTime() + 4,
          mealName: 'supper',
          mealTime: '',
          title: 'Вечеря',
          repeatMenuTitle: 'Повторюємо вечерю попереднього дня',
          titleBtn: '+ Страва вечері',
          menuView: 0,
          twoServings: false,
          repeatMenu: false,
          menuText: [],
        },
      };
      state.menuDay = menuDayDefault;
    },
    // Додає передане меню конкретного дня для редагування
    addMenuEditRedux(state, { payload }) {
      state.menuDay = payload;
    },
    // Обнуляє меню дня
    resetMenuDay(state) {
      state.menuDay = {};
    },
    // Додає номер дня
    addNumberDayRedux(state, { payload }) {
      state.menuDay.dayNumber = payload;

      if (payload < 2) {
        state.menuDay.breakfast.repeatMenu = false;
        state.menuDay.snack.repeatMenu = false;
        state.menuDay.dinner.repeatMenu = false;
        state.menuDay.supper.repeatMenu = false;
      }
    },
    // Додає заберає Посилання на відео з тренуванням
    addTrainingRedux(state, { payload }) {
      state.menuDay.training = payload;
    },
    // Додає страву
    addMealRedux(state, { payload }) {
      // console.log('payload ==== ', payload);
      const mealName = payload;
      const item = {
        id: new Date().getTime(),
        title: '',
        videoUrl: '',
        ingredients: [],
        text: '',
      };

      state.menuDay[mealName].menuText = [...state.menuDay[mealName].menuText, item];
    },
    // Видаляє страву
    removeMealRedux(state, { payload }) {
      // console.log('removeMealRedux/payload ==== ', payload);
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      state.menuDay[mealName].menuText.splice(menuIndex, 1);
    },
    // Додає Назву страви
    addMealItemRedux(state, { payload }) {
      // console.log('addMealTitleRedux/payload === ', payload);
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const inputValue = payload.inputValue;
      const itemName = payload.itemName;

      state.menuDay[mealName].menuText[menuIndex][itemName] = inputValue;
    },
    // Додає інгридієнт
    addIngredientRedux(state, { payload }) {
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const ingredientsItem = payload.ingredientsItem;
      const ingredient = {
        id: generateRandomString(),
        itemActive: 0,
        titleIngredients: false,
        ingredientsItems: [ingredientsItem],
      };

      state.menuDay[mealName].menuText[menuIndex].ingredients.push(ingredient);
    },
    // Додає інгридієнт по вказаному індексу
    addIngredientByIndexRedux(state, { payload }) {
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const ingredientsItem = payload.ingredientsItem;
      const index = payload.indexIngredient + 1;
      const titleIngredients = payload.titleIngredients;
      const ingredient = {
        id: generateRandomString(),
        itemActive: 0,
        titleIngredients: titleIngredients,
        ingredientsItems: [ingredientsItem],
      };
      state.menuDay[mealName].menuText[menuIndex].ingredients.splice(index, 0, ingredient);
    },

    // Додає інгридієнт в заміну інгридієнтів
    addSubIngredientRedux(state, { payload }) {
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const indexIngredientGropIndex = payload.indexIngredientGropIndex;
      const subIngredient = payload.subIngredient;
      state.menuDay[mealName].menuText[menuIndex].ingredients[
        indexIngredientGropIndex
      ].ingredientsItems = [
        ...state.menuDay[mealName].menuText[menuIndex].ingredients[indexIngredientGropIndex]
          .ingredientsItems,
        subIngredient,
      ];
    },
    // Додає заголовок в інгридієнтах
    addTitleIngredientRedux(state, { payload }) {
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const ingredientsItem = payload.ingredientsItem;

      const date = new Date();
      const ingredient = {
        id: date.getTime(),
        itemActive: 0,
        titleIngredients: true,
        ingredientsItems: [{ ...ingredientsItem, titleIngredients: true }],
      };
      state.menuDay[mealName].menuText[menuIndex].ingredients = [
        ...state.menuDay[mealName].menuText[menuIndex].ingredients,
        ingredient,
      ];
    },
    // Видаляє групу інгридієнтів
    removeIngredientsGropRedux(state, { payload }) {
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const indexIngredientGropIndex = payload.indexIngredientGropIndex;
      state.menuDay[mealName].menuText[menuIndex].ingredients.splice(indexIngredientGropIndex, 1);
    },
    // Видаляє інгридієнт
    removeIngredientRedux(state, { payload }) {
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const indexIngredientGropIndex = payload.indexIngredientGropIndex;
      const indexIngredient = payload.indexIngredient;
      state.menuDay[mealName].menuText[menuIndex].ingredients[
        indexIngredientGropIndex
      ].ingredientsItems.splice(indexIngredient, 1);
    },
    // При зміні інпута інгридієнта
    onChangeIngredientRedux(state, { payload }) {
      // console.log('onChangeIngredient/payload === ', payload);
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const indexIngredientGropIndex = payload.indexIngredientGropIndex;
      const indexIngredient = payload.indexIngredient;
      const inputValue = payload.inputValue;
      state.menuDay[mealName].menuText[menuIndex].ingredients[
        indexIngredientGropIndex
      ].ingredientsItems[indexIngredient].text = inputValue;
    },
    //Заміняє обєкт інгридієнта
    onChangeIngredientAndBasketRedux(state, { payload }) {
      // console.log('onChangeIngredient/payload === ', payload);
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const indexIngredientGropIndex = payload.indexIngredientGropIndex;
      const indexIngredient = payload.indexIngredient;
      const objectIngredient = payload.objectIngredient;

      state.menuDay[mealName].menuText[menuIndex].ingredients[
        indexIngredientGropIndex
      ].ingredientsItems[indexIngredient] = objectIngredient;
    },
    // Змінює дані внутрі обєкта інгридієнта з яким прауюєм
    addDataToActiveingredientRedux(state, { payload }) {
      // console.log('addDataToActiveingredientRedux/payload === ', payload);
      const data = payload.data;
      const mealName = payload.mealName;
      const menuIndex = payload.menuIndex;
      const indexIngredientGropIndex = payload.indexIngredientGropIndex;
      const indexIngredient = payload.indexIngredient;

      state.menuDay[mealName].menuText[menuIndex].ingredients[
        indexIngredientGropIndex
      ].ingredientsItems[indexIngredient] = data;
    },

    onChangeMealControlRedux(state, { payload }) {
      const mealName = payload.mealName;
      const item = payload.item;
      const value = payload.value;

      state.menuDay[mealName][item] = value;
    },
  },
});

export const {
  addMenuDayDefaultRedux,
  addMenuEditRedux,
  resetMenuDay,
  addNumberDayRedux,
  addMealRedux,
  removeMealRedux,
  addMealItemRedux,
  onChangeIngredientRedux,
  onChangeIngredientAndBasketRedux,
  removeIngredientsGropRedux,
  removeIngredientRedux,
  addIngredientRedux,
  addTitleIngredientRedux,
  addSubIngredientRedux,
  addDataToActiveingredientRedux,
  onChangeMealControlRedux,
  addIngredientByIndexRedux,
  addTrainingRedux,
} = menuSlice.actions;

export default menuSlice.reducer;
